export default {
    name: 'v5-icon-map',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M512 959.84c-8.77 0-17.17-3.55-23.27-9.85-3.34-3.44-82.64-85.5-163.26-190.93-47.72-62.4-85.85-119.97-113.34-171.09-36.41-67.72-54.11-123.28-54.11-169.85 0-47.77 9.36-94.13 27.83-137.79 17.83-42.15 43.35-80.01 75.85-112.5 32.5-32.5 70.35-58.02 112.5-75.85 43.67-18.46 90.03-27.82 137.8-27.82s94.13 9.36 137.79 27.83c42.16 17.83 80.01 43.35 112.51 75.85 32.5 32.5 58.02 70.35 75.85 112.5 18.47 43.66 27.83 90.02 27.83 137.79 0 46.57-17.7 102.13-54.11 169.85-27.49 51.12-65.62 108.69-113.34 171.09C617.91 864.49 538.61 946.56 535.27 950a32.436 32.436 0 01-23.27 9.84zm0-830.87c-159.44 0-289.16 129.72-289.16 289.16 0 35.04 15.56 81.78 46.24 138.9 25.79 48.02 61.96 102.59 107.5 162.18 52.7 68.97 105.96 128.81 135.41 160.84 29.45-32.02 82.71-91.87 135.41-160.84 45.54-59.59 81.71-114.15 107.5-162.18 30.69-57.13 46.24-103.86 46.24-138.9.02-159.44-129.7-289.16-289.14-289.16z',
                    fill: 'currentColor'
                }
            }),
            h('path', {
                attrs: {
                    d: 'M512 570.98c-79.74 0-144.61-64.87-144.61-144.61S432.26 281.75 512 281.75c79.74 0 144.61 64.87 144.61 144.61S591.74 570.98 512 570.98zm0-224.41c-44 0-79.8 35.8-79.8 79.8s35.8 79.8 79.8 79.8 79.8-35.8 79.8-79.8-35.8-79.8-79.8-79.8z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
